   <!-- Canada Page -->
<div class="dtfprograms" *ngIf="isCanadaPortal">
   <!-- Announcement Banner Code -->
   <div class="dtf-alertpage"></div>
 
 
   <!-- Banner with background image -->
   <section class="mbfs-home-hero" style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Website_FAQs_Header.jpg); background-size: cover; background-position: center;">
     <section class="mbfs-home-hero__header">
       <h2 class="mbfs-home-hero__header-subtitle">
         {{ 'FAQ.Header' | translate }}
       </h2>
       <p class="mbfs-home-hero__header-text-demi" style="text-align: center;">
         {{ 'FAQ.SubTitles1' | translate }}
       </p>
     </section>
   </section>
 
   <!-- Gray background with search text and larger dropdown -->
   <div class="gray-background" style="background-color: #4F4D4A; padding: 40px; text-align: center;">
     <p class="search-text" style="font-family: 'corporateERegular'; font-size: 30px; color: #FFFFFF; white-space: normal;">
                    {{ 'FAQ.Questions' | translate }}
     </p>
     <!-- Larger dropdown with "Select FAQ Topic" inside -->
     <select id="faq-dropdown" class="faq-dropdown">
       <option value="" disabled selected>{{ 'FAQ.SelectTopic' | translate }}</option>
       <option value="#section1">{{ 'FAQ.TopQuestions' | translate }}</option>
       <option value="#section2">{{ 'FAQ.AccountBasics' | translate }}</option>
       <option value="#section3">{{ 'FAQ.Payments' | translate }}</option>
       <option value="#section4">{{ 'FAQ.Payoffs' | translate }}</option>
       <option value="#section5">{{ 'FAQ.Extensions' | translate }}</option>
       <option value="#section6">{{ 'FAQ.Transfers' | translate }}</option>
       <option value="#section7">{{ 'FAQ.Insurance' | translate }}</option>
       <option value="#section8">{{ 'FAQ.LeaseEnd' | translate }}</option>
       <option value="#section9">{{ 'FAQ.EngineRepairs' | translate }}</option>
       <option value="#section10">{{ 'FAQ.Miscellaneous' | translate }}</option>
     </select>
   </div>
<!-- Section 1: Top Questions -->
<section id="section1" class="faq-sectioninfo" style="margin-left: 80px;"></section>
<p style="font-weight: bold; font-size: 18px; color: #4F4D4A; text-align: center;">
   {{ 'FAQ.History' | translate }}
   <a [href]="getEmailLink()">{{ 'FAQ.EmailForCustomers' | translate }}</a>
   {{ 'FAQ.History2' | translate }}
</p>
<section id="section1" class="header-faq">
   <h3 class="custom-heading" style="margin-top: 30px;">{{ 'FAQ.TopQuestions' | translate }}</h3>
   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsMonthly' | translate }}</h3>
      
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsMonthlyAnswer' | translate }}</p>
   
   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsPayments' | translate }}</h3>
   <p class = "custom-paragraph">  {{ 'FAQ.TopQuestionsPaymentsAnswer' | translate }} 
      <a [href]="getPaymentOptionsLink()">{{ 'FAQ.TopQuestionsHere' | translate }}</a> </p>
   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsCheques' | translate }}</h3>
   
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsChequesA' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsAutoPay' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsAutoPayA' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsAutoPay2' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsAutoPayA2' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsPayoff' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsPayoffA' | translate }}</p>

  
   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsJob' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsJobA' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsYearEnd' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsYearEndA' | translate }}</p>


   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsAmort' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsAmortA' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsOwner' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsOwnerA' | translate }}</p>


   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsCopy' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsCopyA' | translate }}</p>


   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsMoved' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsMovedA' | translate }}</p>


   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsPOA' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsPOAA' | translate }}</p>


   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsSecurity' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsSecurityA' | translate }}</p>


   <h3 class="custom-subheading">{{ 'FAQ.TopQuestionsTwoFactor' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsTwoFactorA' | translate }}</p>

   <p class="custom-paragraph">{{ 'FAQ.TopQuestionsTwoFactorB' | translate }}</p>
   <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
</section>

<!-- Section 2: Account Basics -->
<section id="section2" class="header-faq">
   <h3 class = "custom-heading">{{ 'FAQ.AccountBasics' | translate }}</h3>
   
   <h3 class="custom-subheading">{{ 'FAQ.ChangeOfAddress' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.ChangeOfAddressA' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.BankingInformation' | translate }}</h3>
  <p class="custom-paragraph">{{ 'FAQ.BankingInformationA' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.ApplyForCredit' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.ApplyForCreditA' | translate }}</p>


   <h3 class="custom-subheading">{{ 'FAQ.ChangingDueDate' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.ChangingDueDateA' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.InterestPaidLetters' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.InterestPaidLettersA' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.Invoicing' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.InvoicingA' | translate }}</p>


   <h3 class="custom-subheading">{{ 'FAQ.Privacy' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.PrivacyA' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.Plate' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.PlateA' | translate }}</p>


   <h3 class="custom-subheading">{{ 'FAQ.Advantage' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.AdvantageAOne' | translate }}</p>

   <ul class = "custom-paragraph">
      <li>{{ 'FAQ.AdvantageATwo' | translate }}</li>
      <li>{{ 'FAQ.AdvantageAThree' | translate }}</li>
      <li>{{ 'FAQ.AdvantageAFour' | translate }}</li>
      <li>{{ 'FAQ.AdvantageAFive' | translate }}</li>
      <li>{{ 'FAQ.AdvantageASix' | translate }}</li>
      <li>{{ 'FAQ.AdvantageASeven' | translate }}</li>
      <li>{{ 'FAQ.AdvantageAEight' | translate }}</li>
      <li>{{ 'FAQ.AdvantageANine' | translate }}</li>
      <li>{{ 'FAQ.AdvantageATen' | translate }}</li>
   </ul>

   <p class="custom-paragraph">
      {{ 'FAQ.AdvantageAEleven' | translate }}
      <a [href]="getLoginLink()">{{ 'FAQ.AdvantageATwelve' | translate }}</a>
    </p>    
    <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
</section>

<!-- Section 3: Payments -->
<section id="section3" class="header-faq">
 <h3 class = "custom-heading">{{ 'FAQ.Payments' | translate }}</h3>
   
   <h3 class="custom-subheading">{{ 'FAQ.Grace' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.GraceA' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.GSTBalloon' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.GSTBalloonA' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.Refinancing' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.RefinancingA' | translate }}</p>

   
   <h3 class="custom-subheading">{{ 'FAQ.PaymentObligations' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.PaymentObligationsA' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.PaymentOption' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.PaymentOptionA' | translate }}</p>
 
   <h3 class="custom-subheading">{{ 'FAQ.AutoDebt' | translate }}</h3>
      <p class="custom-paragraph">{{ 'FAQ.AutoDebtA' | translate }}</p>

      <h3 class="custom-subheading">{{ 'FAQ.InternetTelephone' | translate }}</h3>
      <p class="custom-paragraph">{{ 'FAQ.InternetTelephoneA' | translate }}</p>

   <h3 class="custom-subheading">{{ 'FAQ.PstExempt' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.PstExemptA' | translate }}</p>

   <!-- "Back to Top" link -->
   <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
</section>

<!-- Section 4: Payoffs -->
<section id="section4" class="header-faq">
   <h3 class = "custom-heading">{{ 'FAQ.Payoffs' | translate }}</h3>
   
   <h3 class="custom-subheading">{{ 'FAQ.PayoffAccount' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.PayoffAccountA' | translate }}</p>
   <p class="custom-paragraph">
      {{ 'FAQ.PayoffAccountB' | translate }}
    </p>
    <p class="custom-paragraph">
      {{ 'FAQ.PayoffAccountC' | translate }}
    </p>
    <p class="custom-paragraph">
      {{ 'FAQ.PayoffAccountD' | translate }}
    </p>
    

   <!-- "Back to Top" link -->
   <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
</section>

<!-- Section 5: Extensions -->
<section id="section5" class="header-faq">
   <h3 class = "custom-heading">{{ 'FAQ.Extensions' | translate }}</h3>
   
   <h3 class="custom-subheading">{{ 'FAQ.ExtensionsL' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.ExtensionsLA' | translate }}</p>

   <!-- "Back to Top" link -->
   <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>

   <hr class="section-divider">
</section>

<!-- Section 6: Transfers -->
<!-- Section 6: Transfers -->
<section id="section6" class="header-faq">
   <h3 class="custom-heading">{{ 'FAQ.Transfers' | translate }}</h3>
   <h3 class="custom-subheading">{{ 'FAQ.TransferLeaseLoan' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanA' | translate }}</p>
   <p class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanB' | translate }}</p>
   <p class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanC' | translate }}</p>
   <p class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanD' | translate }}</p>
   <p class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanE' | translate }}</p>
   <ul>
     <li class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanF' | translate }}</li>
     <li class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanG' | translate }}</li>
     <li class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanH' | translate }}</li>
   </ul>
   <p class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanI' | translate }}</p>
   <ul>
     <li class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanJ' | translate }}</li>
     <li class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanK' | translate }}</li>
     <li class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanL' | translate }}</li>
     <li class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanM' | translate }}</li>
     <li class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanN' | translate }}</li>
     <li class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanO' | translate }}</li>
   </ul>
   <p class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanP' | translate }}</p>
   <p class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanQ' | translate }}</p>
   <p class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanR' | translate }}</p>
   <p class="custom-paragraph">{{ 'FAQ.TransferLeaseLoanS' | translate }}</p>
 
   <!-- "Back to Top" link -->
   <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
 </section>
 
   

<!-- Insurance-->
   <section id="section7" class="header-faq">
      <h3 class="custom-heading">{{ 'FAQ.Insurance' | translate }}</h3>
   
      <h3 class="custom-subheading">{{ 'FAQ.InsuranceRequirements' | translate }}</h3>
      <p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsA' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsB' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsC' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsD' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsE' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsF' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsG' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsH' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsI' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsJ' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsK' | translate }}</p>
      <p class="custom-paragraph">{{'FAQ.InsuranceRequirementsL' | translate }}</p>


      
   
   </section>
   <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
   
<!-- Lease End Options-->
   <section id="section8" class="header-faq">
      <h3 class="custom-heading">{{ 'FAQ.LeaseEnd' | translate }}</h3>
   
      <p class="custom-paragraph">{{ 'FAQ.LeaseEndA' | translate }}</p>
   
      <!-- "Back to Top" link -->
      <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
      <hr class="section-divider">
   </section>
   
<!-- Engine Reapairs-->
   <section id="section9" class="header-faq  ">
   <h3 class = "custom-heading">{{ 'FAQ.EngineRepairs' | translate }}</h3>
      <h3 class="custom-subheading">{{ 'FAQ.EngineRepairFinancing' | translate }}</h3>
         <p class="custom-paragraph">{{ 'FAQ.EngineOverhaulA' | translate }}</p>
         <p class="custom-paragraph">{{ 'FAQ.EngineOverhaulB' | translate }}</p>
         <ul>
           <li class="custom-paragraph">{{ 'FAQ.EngineOverhaulD' | translate }}</li>
           <li class="custom-paragraph">{{ 'FAQ.EngineOverhaulE' | translate }}</li>
           <li class="custom-paragraph">{{ 'FAQ.EngineOverhaulF' | translate }}</li>
           <li class="custom-paragraph">{{ 'FAQ.EngineOverhaulG' | translate }}</li>
           <li class="custom-paragraph">{{ 'FAQ.EngineOverhaulH' | translate }}</li>
           <li class="custom-paragraph">{{ 'FAQ.EngineOverhaulI' | translate }}</li>
           <li class="custom-paragraph">{{ 'FAQ.EngineOverhaulJ' | translate }}</li>
           <li class="custom-paragraph">{{ 'FAQ.EngineOverhaulK' | translate }}</li>
           <li class="custom-paragraph">{{ 'FAQ.EngineOverhaulL' | translate }}</li>
           <li class="custom-paragraph">{{ 'FAQ.EngineOverhaulM' | translate }}</li>
           <li class="custom-paragraph">{{ 'FAQ.EngineOverhaulN' | translate }}</li>
         </ul>
       
      <!-- "Back to Top" link -->
      <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
      <hr class="section-divider">
   </section>
   <!-- Misc-->
   <section id="section10" class="header-faq">
      <h3 class = "custom-heading">{{ 'FAQ.Miscellaneous' | translate }}</h3>
   

      <p class = "custom-paragraph">
         {{ 'FAQ.MiscellaneousA' | translate }}
         <a [href]="getDealerLocatorLink()">{{ 'FAQ.MiscellaneousLink' | translate }}</a>
         {{ 'FAQ.MiscellaneousB' | translate }}
      </p>

   
      <!-- "Back to Top" link -->
      <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
      <hr class="section-divider">
   </section>
</div>
<!-- U.S Page -->
<div class="dtfprograms" *ngIf="!isCanadaPortal">
   <div class="dtf-alertpage"></div>
 
   <!-- Banner with background image -->
   <section class="mbfs-home-hero" style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Website_FAQs_Header.jpg); background-size: cover; background-position: center;">
     <section class="mbfs-home-hero__header">
       <h2 class="mbfs-home-hero__header-subtitle">
         {{ 'FAQ.Header' | translate }}
       </h2>
       <p class="mbfs-home-hero__header-text-demi">
         {{ 'FAQ.SubTitles1' | translate }}
       </p>
     </section>
   </section>
 
   <!-- Gray background with search text and larger dropdown -->
   <div class="gray-background" style="background-color: #4F4D4A; padding: 40px; text-align: center;">
     <p class="search-text" style="font-family: 'Corporate S Demi'; font-size: 30px; color: #FFFFFF; white-space: normal;">
       {{ 'FAQ.Questions' | translate }}
     </p>
     <!-- Larger dropdown with "Select FAQ Topic" inside -->
     <select id="faq-dropdown" class="faq-dropdown">
       <option value="" disabled selected>{{ 'FAQ.SelectTopic' | translate }}</option>
       <option value="#AccidentTheftSection">{{ 'FAQ.AccidentOrTheft' | translate }}</option>
       <option value="#CreditDispute">{{ 'FAQ.CreditDispute' | translate }}</option>
       <option value="#dashboard-tile1">{{ 'FAQ.Titles' | translate }}</option>
       <option value="#EngineRepairs">{{ 'FAQ.EngineRepair' | translate }}</option>
       <option value="#gracesection">{{ 'FAQ.GracePeriod' | translate }}</option>
       <option value="#invoicesection">{{ 'FAQ.Invoices' | translate }}</option>
       <option value="#InsuranceRequirementsSection">{{ 'FAQ.InsuranceRequirements1' | translate }}</option>
       <option value="#MiscSection">{{ 'FAQ.Miscellaneous' | translate }}</option>
       <option value="#online-self-service">{{ 'FAQ.OnlineSelfService' | translate }}</option>
       <option value="#PaymentOptions">{{ 'FAQ.Payments' | translate }}</option>
       <option value="#RefinancingSection">{{ 'FAQ.Refinancing1' | translate }}</option>
       <option value="#statetostatesection">{{ 'FAQ.StateToStateTransfers' | translate }}</option>
       <option value="#TransferEquitySection">{{ 'FAQ.TransferOfEquity' | translate }}</option>
       <option value="#yearendsection">{{ 'FAQ.YearEndLetters' | translate }}</option>
     </select>
   </div>
 
   <section id="online-self-service" class="header-faq">
      <h3 class="custom-heading" style="margin-top: 30px;">{{ 'FAQ.OnlineSelfServiceHeading' | translate }}</h3>
     <p class="custom-paragraph">{{ 'FAQ.OnlineSelfServiceDescription' | translate }}</p>
 
     <h3 class="custom-subheading">{{ 'FAQ.OnlineSelfServiceRegistration' | translate }}</h3>
     <p class="custom-paragraph">{{ 'FAQ.OnlineSelfServiceRegistrationDescription' | translate }}</p>
 
     <h3 class="custom-subheading">{{ 'FAQ.OnlineSelfServiceAccountDashboard' | translate }}</h3>
     <p class="custom-paragraph">{{ 'FAQ.OnlineSelfServiceAccountDashboardDescription' | translate }}</p>
 
     <h3 class="custom-subheading">{{ 'FAQ.DashboardHeading' | translate }}</h3>
     <p class="custom-paragraph">{{ 'FAQ.DashboardDescription' | translate }}</p>
   </section>
   
 
   <section id="dashboard-tile1" class="header-faq">
     <h3 class="custom-subheading">{{ 'FAQ.DashboardTile1' | translate }}</h3>
     <p class="custom-paragraph">{{ 'FAQ.DashboardTile1Description' | translate }}</p>
     <ul>
       <li class="custom-subheading">{{ 'FAQ.DashboardTile2' | translate }}</li>
       <p class="custom-paragraph">{{ 'FAQ.DashboardTile2Description' | translate }}</p>
       <li class="custom-subheading">{{ 'FAQ.DashboardTile3' | translate }}</li>
       <p class="custom-paragraph">{{ 'FAQ.DashboardTile3Description' | translate }}</p>
 
       <li class="custom-subheading">{{ 'FAQ.DashboardTile4' | translate }}</li>
       <p class="custom-paragraph">{{ 'FAQ.DashboardTile4Description' | translate }}</p>
 
       <li class="custom-subheading">{{ 'FAQ.DashboardTile5' | translate }}</li>
       <p class="custom-paragraph">{{ 'FAQ.DashboardTile5Description' | translate }}</p>
 
       <li class="custom-subheading">{{ 'FAQ.DashboardTile6' | translate }}</li>
       <p class="custom-paragraph">{{ 'FAQ.DashboardTile6Description' | translate }}</p>
 
       <li class="custom-subheading">{{ 'FAQ.DashboardTile7' | translate }}</li>
       <p class="custom-paragraph">{{ 'FAQ.DashboardTile7Description' | translate }}</p>
 
       <li class="custom-subheading">{{ 'FAQ.DashboardTile8' | translate }}</li>
       <p class= "custom-paragraph">{{ 'FAQ.DashboardTile8Description' | translate }}</p>
 
       <li class="custom-subheading">{{ 'FAQ.DashboardTile9' | translate }}</li>
       <p class="custom-paragraph">{{ 'FAQ.DashboardTile9Description' | translate }}</p>
       <p class="custom-paragraph">{{ 'FAQ.DashboardTile9DescriptionB' | translate }}</p>
       <p class="custom-paragraph">{{ 'FAQ.DashboardTile9DescriptionC' | translate }}</p>
       <p class="custom-paragraph">{{ 'FAQ.DashboardTile9DescriptionD' | translate }}</p>
 
       <li class="custom-subheading">{{ 'FAQ.DashboardTile10' | translate }}</li>
       <p class="custom-paragraph">{{ 'FAQ.DashboardTile10Description' | translate }}</p>
     </ul>
        <!-- "Back to Top" link -->
        <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
        
   <hr class="section-divider">
   </section>
   <section id="invoicesection" class="header-faq">
     <h3 class="custom-heading">{{ 'FAQ.Invoice' | translate }}</h3>
     <h3 class="custom-subheading">{{ 'FAQ.HowInvoice' | translate }}</h3>
     <p class="custom-paragraph">{{ 'FAQ.HowInvoiceA' | translate }}</p>
        <!-- "Back to Top" link -->
        <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
   </section>
   <section id="PaymentOptions" class="header-faq">
     <h3 class="custom-heading">{{ 'FAQ.PaymentOptionHeader' | translate }}</h3>
     <h3 class="custom-subheading">{{ 'FAQ.HowPaymentOption' | translate }}</h3>
     <p class="custom-paragraph">{{ 'FAQ.HowPaymentOptionA' | translate }}</p>
     <ul>
       <li class="custom-subheading">{{ 'FAQ.PaymentOption1' | translate }}</li>
       <p class="custom-paragraph">{{ 'FAQ.PaymentOption1Auto' | translate }}</p>
       <p class="custom-paragraph">{{ 'FAQ.PaymentOption1Online' | translate }}</p>
 
       <li class="custom-subheading">{{ 'FAQ.PaymentOption2' | translate }}</li>
       <p class="custom-paragraph">{{ 'FAQ.PhonePay' | translate }}</p>
       <p class="custom-paragraph">{{ 'FAQ.PaymentOptionRepay' | translate }}</p>
       <p class="custom-paragraph">{{ 'FAQ.PaymentOptionMail' | translate }}</p>
       <div>
         <img src="/static/assets/img/dtf-assets/images/redesign/DTF_FAQs.png" style="max-width: 100%;" class="custom-image">
       </div>
       <p class="custom-subheading custom-subheading-desktop">{{ 'FAQ.OvernightTitle' | translate }}</p>
       <div>
        <img src="/static/assets/img/dtf-assets/images/redesign/DTF_FAQs_Chart2.png" style="max-width: 100%;" class="custom-image">
       </div>
       <p class="custom-subheading custom-subheading-desktop">{{ 'FAQ.WesternUnionTitle' | translate }}</p>
       <p class="custom-paragraph" >{{ 'FAQ.WesternUnionAddress1' | translate }}</p>
       <p class="custom-paragraph" >{{ 'FAQ.WesternUnionAddress2' | translate }}</p>
       <p class="custom-paragraph" >{{ 'FAQ.WesternUnionAddress3' | translate }}</p>
     </ul>
     <div class="faq-block">
      <p class="custom-subheading">{{ 'FAQ.PayByMailQuestion' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.PayByMailAnswer' | translate }}</p>
    
      <p class="custom-subheading">{{ 'FAQ.AutoPayCompletionQuestion' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.AutoPayCompletionAnswer' | translate }}</p>
    
      <p class="custom-subheading">{{ 'FAQ.ChangeAutoPayBankQuestion' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.ChangeAutoPayBankAnswer' | translate }}</p>
    
      <p class="custom-subheading">{{ 'FAQ.AutoPayPaperStatementsQuestion' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.AutoPayPaperStatementsAnswer' | translate }}</p>
    
      <p class="custom-subheading">{{ 'FAQ.OnlinePaymentsPostingQuestion' | translate }}</p>
      <p class= "custom-paragraph">{{ 'FAQ.OnlinePaymentsPostingAnswer' | translate }}</p>
    
      <p class="custom-subheading">{{ 'FAQ.BankPaymentOverPhoneQuestion' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.BankPaymentOverPhoneAnswer' | translate }}</p>
    
      <p class="custom-subheading">{{ 'FAQ.WithdrawalTimeForPhonePaymentQuestion' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.WithdrawalTimeForPhonePaymentAnswer' | translate }}</p>
    
      <p class="custom-subheading">{{ 'FAQ.CreditForPhonePaymentQuestion' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.CreditForPhonePaymentAnswer' | translate }}</p>
    
      <p class="custom-subheading">{{ 'FAQ.PaymentWithoutAccountRegistrationQuestion' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.PaymentWithoutAccountRegistrationAnswer' | translate }}</p>
    </div>
    
       <!-- "Back to Top" link -->
       <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
   </section>
   <section id="gracesection" class="header-faq">
      <p class="custom-heading">{{ 'FAQ.GracePeriodQuestion1' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.GracePeriodAnswer1' | translate }}</p>
    
      <p class="custom-subheading">{{ 'FAQ.GracePeriodQuestion2' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.GracePeriodAnswer2' | translate }}</p>
    
      <p class="custom-subheading">{{ 'FAQ.GracePeriodQuestion3' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.GracePeriodAnswer3' | translate }}</p>
    
      <p class="custom-subheading">{{ 'FAQ.GracePeriodQuestion4' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.GracePeriodAnswer4' | translate }}</p>
    
      <p class="custom-subheading">{{ 'FAQ.GracePeriodQuestion5' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.GracePeriodAnswer5' | translate }}</p>
    
      <p class="custom-subheading">{{ 'FAQ.GracePeriodQuestion6' | translate }}</p>
      <p class="custom-paragraph">{{ 'FAQ.GracePeriodAnswer6' | translate }}</p>
         <!-- "Back to Top" link -->
         <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
</section>    
<section id="yearendsection" class="header-faq">
   <h3 class="custom-heading">{{ 'FAQ.YearEnd' | translate }}</h3>
<p class="custom-subheading">{{ 'FAQ.YearEndInterestQuestion1' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.YearEndInterestAnswer1' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.YearEndInterestQuestion2' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.YearEndInterestAnswer2' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.YearEndInterestQuestion3' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.YearEndInterestAnswer3' | translate }}</p>
   <!-- "Back to Top" link -->
   <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
</section>
<section id="statetostatesection" class="header-faq">
   <h3 class="custom-heading">{{ 'FAQ.StateToState' | translate }}</h3>
   <p class="custom-paragraph">{{ 'FAQ.StateToStateA' | translate }}</p>
   <p class="custom-paragraph">{{ 'FAQ.StateToStateB' | translate }}</p>
   <div>
    <img src="/static/assets/img/dtf-assets/images/redesign/DTF_FAQs_Chart3.png" style="max-width: 100%;" class="custom-image">
   </div>
   <p class="custom-paragraph" style="padding-top: 10px;">{{ 'FAQ.StateElectronic' | translate }}</p>
    <div>
      <img src="/static/assets/img/dtf-assets/images/redesign/DTF_FAQs_Chart4.png" style="max-width: 100%;" class="custom-image">
     </div>
        <!-- "Back to Top" link -->
        <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
</section>
<section id="TilesSection" class="header-faq">
   <p class="custom-heading">{{ 'FAQ.Titles1' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.GetCopyOfTitle' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.GetCopyOfTitleAnswer' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.ExpiredRegistration' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.ExpiredRegistrationAnswer' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.PowerOfAttorney' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.PowerOfAttorneyAnswer' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.PayoffTitle' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.PayoffTitleAnswer' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.ThirdPartyPayoff' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.ThirdPartyPayoffAnswer' | translate }}</p>
   <!-- "Back to Top" link -->
   <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
   </section>
   <section id="TransferEquitySection" class="header-faq">
<p class="custom-heading">{{ 'FAQ.TitleEquity' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.Circumstances' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.TransferToNewParty' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.TransferToNewPartyDesc' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.TransferToBusinessName' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.TransferToBusinessNameDesc' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.FeesRequired' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.FeesRequiredDesc' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.BackPaymentsRolledOver' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.BackPaymentsDesc' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.OtherFees' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.OtherFeesDesc' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.SalesTax' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.SalesTaxDesc' | translate }}</p>

<p class="custom-subheading">{{ 'FAQ.Paperwork' | translate }}</p>
<p class="custom-paragraph">{{ 'FAQ.PaperworkDesc' | translate }}</p>
<ul>
   <li><p class="custom-paragraph">{{ 'FAQ.ContinuingGuaranty' | translate }}</p></li>
   <li><p class="custom-paragraph">{{ 'FAQ.ArticlesOfIncorporation' | translate }}</p></li>
   <li><p class="custom-paragraph">{{ 'FAQ.SecretarysCertificate' | translate }}</p></li>
   <li><p class="custom-paragraph">{{ 'FAQ.PartnershipAgreement' | translate }}</p></li>
   <li><p class="custom-paragraph">{{ 'FAQ.LimitedPartnershipCertificate' | translate }}</p></li>
   <li><p class="custom-paragraph">{{ 'FAQ.InsuranceCertificate' | translate }}</p></li>
   <li><p class="custom-paragraph">{{ 'FAQ.OriginalTitle' | translate }}</p></li>
   <li><p class="custom-paragraph">{{ 'FAQ.DriversLicense' | translate }}</p></li>
   <li><p class="custom-paragraph">{{ 'FAQ.CabCardRegistration' | translate }}</p></li>
   <li><p class="custom-paragraph">{{ 'FAQ.SalesTaxExemptionCertificate' | translate }}</p></li>
</ul>
   <!-- "Back to Top" link -->
   <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">

      </section>

      <section id="EngineRepairs" class="header-faq">
         <p class="custom-heading">{{ 'FAQ.EngineRepairs' | translate }}</p>
     
         <p class="custom-paragraph" >{{ 'FAQ.EngineRepairsInfo' | translate }}</p>
     
         <p class="custom-subheading">{{ 'FAQ.FinancingEngineRepairs' | translate }}</p>
         <p class="custom-paragraph">{{ 'FAQ.FinancingEngineRepairsQ' | translate }}</p>
     
         <p class="custom-subheading">{{ 'FAQ.RequiredDocumentation' | translate }}</p>
         <ul>
            <li><p class="custom-paragraph">{{ 'FAQ.RequiredDocumentationItem1' | translate }}</p></li>
          <li><p class="custom-paragraph">{{ 'FAQ.RequiredDocumentationItem2' | translate }}</p></li>
          <li><p class="custom-paragraph">{{ 'FAQ.RequiredDocumentationItem3' | translate }}</p></li>
          <li><p class="custom-paragraph">{{ 'FAQ.RequiredDocumentationItem4' | translate }}</p></li>
          <li><p class="custom-paragraph">{{ 'FAQ.RequiredDocumentationItem5' | translate }}</p></li>
         <li><p class="custom-paragraph">{{ 'FAQ.RequiredDocumentationItem6' | translate }}</p></li>
         <li><p class="custom-paragraph">{{ 'FAQ.RequiredDocumentationItem7' | translate }}</p></li>
         <li><p class="custom-paragraph">{{ 'FAQ.RequiredDocumentationItem8' | translate }}</p></li> 
         </ul>
     
         <p class="custom-subheading">{{ 'FAQ.FinancingTrucks' | translate }}</p>
         <p class="custom-paragraph">{{ 'FAQ.FinancingTrucksQ' | translate }}</p>
         <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
         <hr class="section-divider">
      </section>
      <section id="RefinancingSection" class="header-faq">
         <p class="custom-heading">{{ 'FAQ.Refinancing1' | translate }}</p>

         <p class="custom-paragraph">{{ 'FAQ.RefinancingInfo' | translate }}</p>
     
         <p class="custom-subheading">{{ 'FAQ.RollingBackPayments' | translate }}</p>
         <p class="custom-paragraph">{{ 'FAQ.RollingBackPaymentsQ' | translate }}</p>
         <p class="custom-subheading">{{ 'FAQ.RollingBackPaymentsA' | translate }}</p>
     
         <p class="custom-paragraph">{{ 'FAQ.NewPaymentAmount' | translate }}</p>
         <p class="custom-subheading">{{ 'FAQ.NewPaymentAmountQ' | translate }}</p>
         <p class="custom-paragraph">{{ 'FAQ.NewPaymentAmountA' | translate }}</p>
     
         <p class="custom-subheading">{{ 'FAQ.FinancingBalloonPayment' | translate }}</p>
         <p class="custom-paragraph">{{ 'FAQ.FinancingBalloonPaymentQ' | translate }}</p>
            <!-- "Back to Top" link -->
            <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
         </section>
         <section id="AccidentTheftSection" class="header-faq">
            <p class="custom-heading">{{ 'FAQ.AccidentTheftVehicle' | translate }}</p>
            <p  class="custom-paragraph">{{ 'FAQ.AccidentTheftInfo' | translate }}</p>
        
            <p class="custom-subheading">{{ 'FAQ.WhatToDoStolenOrAccident' | translate }}</p>
            <p class="custom-paragraph">{{ 'FAQ.WhatToDoStolenOrAccidentQ' | translate }}</p>
            
            <p class="custom-subheading">{{ 'FAQ.WhatToDoStolenOrAccidentA' | translate }}</p>
            <p class="custom-paragraph">{{ 'FAQ.InsuranceCheckPayable' | translate }}</p>
            <p class="custom-paragraph">{{ 'FAQ.InsuranceCheckPayableQ' | translate }}</p>
            <p class="custom-paragraph">{{ 'FAQ.InsuranceCheckPayableA' | translate }}</p>
            <p class="custom-paragraph">{{ 'FAQ.InsuranceCheckPayableC' | translate }}</p>
            <p class="custom-paragraph">{{ 'FAQ.InsuranceCheckPayableD' | translate }}</p>
            <p class="custom-paragraph">{{ 'FAQ.InsuranceCheckPayableE' | translate }}</p>
         
        
            <p class="custom-subheading">{{ 'FAQ.OptionsReleaseVehicle' | translate }}</p>
            <p class="custom-paragraph">{{ 'FAQ.OptionsReleaseVehicle1' | translate }}</p>
            <p class="custom-paragraph">{{ 'FAQ.OptionsReleaseVehicle2' | translate }}</p>
            <p class="custom-paragraph">{{ 'FAQ.OptionsReleaseVehicle3' | translate }}</p>
         <!-- "Back to Top" link -->
         <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
            </section>
            <section id="InsuranceRequirementsSection" class="header-faq">
               <p class="custom-heading">{{ 'FAQ.InsuranceRequirements1' | translate }}</p>
               <p  class="custom-paragraph">{{ 'FAQ.InsuranceRequirements2' | translate }}</p>
               <p  class="custom-subheading">{{ 'FAQ.InsuranceRequirements3' | translate }}</p>
               <p  class="custom-paragraph">{{ 'FAQ.InsuranceRequirements4' | translate }}</p>
               <ul>
                  <li><p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsItem1' | translate }}</p></li>
                  <li><p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsItem2' | translate }}</p></li>
                  <li><p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsItem3' | translate }}</p></li>
                  <li><p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsItem4' | translate }}</p></li>
                  <li><p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsItem5' | translate }}</p></li>
                  <li><p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsItem6' | translate }}</p></li>
                  <li><p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsItem7' | translate }}</p></li>
                  <li><p class="custom-paragraph">{{ 'FAQ.InsuranceRequirementsItem8' | translate }}</p></li>
              </ul>
                 <!-- "Back to Top" link -->
                 <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>

   <hr class="section-divider">
               </section>
            <section id="MiscSection" class="header-faq">
               <p class="custom-heading">{{ 'FAQ.Miscellaneous1' | translate }}</p>

               <p class="custom-subheading">{{ 'FAQ.OwnerOperatorTravel' | translate }}</p>
               <p class="custom-paragraph">{{ 'FAQ.OwnerOperatorTravelQ' | translate }}</p>
               <p class="custom-subheading">{{ 'FAQ.OwnerOperatorTravelA' | translate }}</p>
           
               <p class="custom-paragraph">{{ 'FAQ.BuyRepossessedTruck' | translate }}</p>
               <p class="custom-subheading">{{ 'FAQ.BuyRepossessedTruckQ' | translate }}</p>
               <p class="custom-paragraph">{{ 'FAQ.BuyRepossessedTruckA' | translate }}</p>
           
               <p class="custom-subheading">{{ 'FAQ.TaxExemptStatus' | translate }}</p>
               <p class="custom-paragraph">{{ 'FAQ.TaxExemptStatusQ' | translate }}</p>
               <p class="custom-subheading">{{ 'FAQ.TaxExemptStatusA' | translate }}</p>
           
               <p class="custom-paragraph">{{ 'FAQ.ForwardTaxBill' | translate }}</p>
               <p class="custom-subheading">{{ 'FAQ.ForwardTaxBillQ' | translate }}</p>
               <p class="custom-paragraph">{{ 'FAQ.ForwardTaxBillA' | translate }}</p>
           
               <p class="custom-paragraph">{{ 'FAQ.SecurityVerification' | translate }}</p>
                  <!-- "Back to Top" link -->
                  <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
               </section>

            <section id="CreditDispute" class="header-faq">
               <p class="custom-heading">{{ 'FAQ.CreditDispute' | translate }}</p>
               <p class="custom-paragraph">{{ 'FAQ.CreditDisputeVer1' | translate }}</p>
                              
            <div class="column-text">
               <p class="custom-paragraph">{{ 'FAQ.CreditDisputeMailingAddress1' | translate }}</p>
               <p class="custom-paragraph">{{ 'FAQ.CreditDisputeMailingAddress2' | translate }}</p>
               <p class="custom-paragraph">{{ 'FAQ.CreditDisputeMailingAddress3' | translate }}</p>
            </div>

                  <!-- "Back to Top" link -->
                  <a class="scrolllinks return-link" href="javascript:void(0);" (click)="scrollToTop()" style="color: #00566A;">{{ 'FAQ.Return' | translate }}</a>
   <hr class="section-divider">
               </section>
</div>
 